import { Component, OnDestroy, Input, OnInit, Optional, AfterViewChecked } from '@angular/core';
import { FormGroup } from '@angular/forms';

import * as Services from '@shared/core/services';
import * as Utils from '@shared/core/utils';
import { Controllers } from '@shared/core/controllers';
import { ScrollService } from '@shared/core/directives/scroll/scroll.shared.service';

import { ModalViewComponent } from '../modal-view.shared.component';
import { Observable } from 'rxjs';

@Component({
    selector: 'shared-modal-for-auth',
    templateUrl: './modal-for-auth.shared.component.html',
    styleUrls: ['./modal-for-auth.shared.component.scss']
})
export class ModalForAuthComponent extends ModalViewComponent implements OnDestroy, OnInit, AfterViewChecked {
    private _closeTimeout: number;
    public formControl: FormGroup;

    @Input() public delay: number = 5000;

    public authenticationStep$: Observable<OLO.Enums.AUTH_STEP>;

    public loading$: Observable<OLO.Components.LOADING_STATUS>;
    constructor(
        public modalsService: Services.ModalsService,
        public heightAdjustService: Services.HeightAdjustService,
        public scrollService: ScrollService,
        public controllers: Controllers,
        @Optional() public formsService: Services.FormsService,
    ) {
        super(modalsService, heightAdjustService, scrollService);

        this.size = 'sm';
    }

    ngOnInit(): void {
        this.authenticationStep$ = this.controllers.members.getAuthenticationStep$();

        this.loading$ = this.controllers.members.signUpInitStatus$();
    }

    ngAfterViewChecked(): void {
        if (!this.formControl && this.formsService) {
            this.formControl = this.formsService.getFormControl('sign-up');
        }
    }

    ngOnDestroy(): void {
        if (this._closeTimeout) {
            clearTimeout(this._closeTimeout);
        }
    }

    public handleStepChange(step: OLO.Enums.AUTH_STEP): void {
        if (step === OLO.Enums.AUTH_STEP.LOGIN_SUCCESS) {
            this.handleCloseClick(null);
            return;
        }

        if (step === OLO.Enums.AUTH_STEP.REGISTER_SUCCESS || step === OLO.Enums.AUTH_STEP.UPDATE_SUCCESS) {
            if (this._closeTimeout) {
                clearTimeout(this._closeTimeout);
            }

            this._closeTimeout = window.setTimeout(() => {
                this.handleCloseClick(null);
            }, this.delay);
        }

        setTimeout(() => {
            this.handleHeightUpdate();
        }, 100);

    }

    public handleTermsClick($event: Event): void {
        console.log('TODO');
    }
}
